// Mantine v5 keeps the label/control wiring that screen readers rely on, so
// Switch and Textarea stay Mantine components and only their painted surfaces
// are replaced here.

export const switchStyles = {
  root: { width: "100%" },
  body: {
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
  },
  labelWrapper: { flex: "1 1 auto", minWidth: 0, paddingLeft: 0 },
  label: {
    padding: 0,
    fontSize: "0.8125rem",
    fontWeight: 600,
    lineHeight: 1.4,
    color: "#232840",
    cursor: "pointer",
  },
  description: {
    marginTop: "0.2rem",
    fontSize: "0.75rem",
    lineHeight: 1.5,
    color: "#949cb4",
  },
  track: {
    cursor: "pointer",
    width: "2.4rem",
    minWidth: "2.4rem",
    height: "1.35rem",
    border: "1px solid rgba(86, 102, 146, 0.16)",
    backgroundColor: "rgba(86, 102, 146, 0.12)",
    transition: "background-color 320ms cubic-bezier(0.32, 0.72, 0, 1)",
  },
  thumb: {
    width: "1rem",
    height: "1rem",
    border: "none",
    boxShadow: "0 1px 3px rgba(31, 45, 80, 0.2)",
    transition: "left 420ms cubic-bezier(0.32, 0.72, 0, 1)",
  },
};

export const textareaStyles = {
  label: {
    marginBottom: "0.4rem",
    fontSize: "0.6875rem",
    fontWeight: 700,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    color: "#5b6382",
  },
  input: {
    padding: "0.7rem 0.8rem",
    borderRadius: "0.7rem",
    border: "1px solid rgba(86, 102, 146, 0.16)",
    backgroundColor: "#ffffff",
    fontSize: "0.875rem",
    lineHeight: 1.6,
    color: "#232840",
    transition: "border-color 320ms cubic-bezier(0.32, 0.72, 0, 1)",
    "&:focus": { borderColor: "#39a8f0" },
  },
};
